import { constants } from "../../misc/constants";
import Scenario1 from "./Scenario1";
import { SbarUIConfig } from "../../components/ui/SbarUI";
import { TransformUIConfig } from "../../components/ui/TransformUI";
import MedsurgBaseScenarioPart from "../MedsurgBaseScenarioPart";
import { Window508Type } from "../MedsurgBaseScenario";

export default class Scenario1Part3 extends MedsurgBaseScenarioPart {

	chapterIds = {
		chapterCinematic1: 'medsurg-cinematic-1-1',
		chapterCinematic11: 'medsurg-cinematic-1-11',
        chapterCinematic12: 'medsurg-cinematic-1-12',
        chapterCinematic13: 'medsurg-cinematic-1-13',
        chapterCinematic14: 'medsurg-cinematic-1-14', //CAN BE REPLACED
        chapterCinematic15: 'medsurg-cinematic-1-15',
        chapterCinematic16: 'medsurg-cinematic-1-16',
        chapterCinematic17: 'medsurg-cinematic-1-17',
		chapterCinematic76: 'medsurg-cinematic-1-76', // for testing - currently set to female 01
		chapterCinematic77: 'medsurg-cinematic-1-77', // for testing - currently set to female 02
		chapterCinematic74: 'medsurg-cinematic-1-74', // for testing - currently set to male 01
		chapterCinematic75: 'medsurg-cinematic-1-75', // for testing - currently set to male 02
		//NEED FAIL ANIMS (4 ANIMATIONS)
		//NEED NASAL CANNULA ANIM
	}

	constructor(scenario: Scenario1, private onDone: () => void){
		super(scenario);
	}

	private PrInstanceID: string;
	private TalkInstanceID1: string;
	private ActionInstanceID1: string;
	private RememberDisplayed: boolean = false;
	private ActionInstanceID2: string;
	private MoveInstanceID: string;
	

	private Talk1: boolean = false;
	private Talk2: boolean = false;
	private Action1: boolean = false;
	private Action2: boolean = false;
	private Action3: boolean = false;
	private Action4: boolean = false;
	private Action21: boolean = false;
	private Action22: boolean = false;
	private Action23: boolean = false;
	private Action24: boolean = false;
	private Action25: boolean = false;

	private TalkCount: number = 0;
	private OldTalkCount: number = 0;
	private ActionCount: number = 0;
	private OldActionCount: number = 0;
	
	private PAbool: boolean = false;
	private PObool: boolean = false;
	
	private avatar1: boolean = false;
	private avatar2: boolean = false;
	private avatar3: boolean = false;
	private avatar4: boolean = false;

	public get partId(): string {
		return constants.scenarios.scenario1.parts.level1Part3.id;
	}

	public get videoUrl(): string[] {
		//return ['./assets/videos/scenario1/video1' + this.scenario.avatarIndx + '.mp4'];
		return ['./assets/videos/scenario1/video10.mp4'];
	}

	public start() {
		const context = this;
		if(this.scenario.avatarIndx === 0) {
			this.avatar1 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 1) {
			this.avatar2 = true;
			this.avatar1 = false;
			this.avatar3 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 2) {
			this.avatar3 = true;
			this.avatar2 = false;
			this.avatar1 = false;
			this.avatar4 = false;
		}
		else if(this.scenario.avatarIndx === 3) {
			this.avatar4 = true;
			this.avatar2 = false;
			this.avatar3 = false;
			this.avatar1 = false;
		}
		this.RememberDisplayed = false;
		context.segment1Step1IntroWalking();
	}

	private segment1Step1IntroWalking() {
		var context = this;
		this.scenario.destroyAllUIInstances();
		context.scenario.displayHeader();
		this.scenario.playAmbientLoop(this.scenario.audioHall);
		this.playVideoChapter(this.chapterIds.chapterCinematic1, () => {
			context.segment1Step2ContinueRoom1();
		});
    }

	private segment1Step4Remember() {
		var context = this;
		this.scenario.update508Window(Window508Type.Remember);
		this.scenario.displayRemember(() => {
			this.scenario.update508Window(Window508Type.Main);
			this.RememberDisplayed = true;
			context.scenario.destroyAllUIInstances();
			//context.skipPart();
		});
	}
	//use when skipping part for testing
	private skipPart() {
		var context = this;
		context.scenario.hideFooter();
        this.scenario.displayModalPop(
			null,
            'Skipping to part 4',
            () => {
                context.scenario.destroyAllUIInstances();
                    context.segment1StepFinal();
            }
        );
	}

    private segment1Step2ContinueRoom1() {
		this.scenario.stopAmbientLoop();
		this.scenario.playAmbientLoop(this.scenario.audioRoom);
		this.scenario.destroyAllUIInstances();
        var context = this;
		context.scenario.gameManager.environment.blurFadeIn();
        this.scenario.displayModalPop(
			null,
            "Mr. Holder has returned from his IVF procedure.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
                context.playVideoChapter(this.chapterIds.chapterCinematic15, () => {}, true);
                context.PreloadUis();
				if(this.RememberDisplayed === false) {
					context.segment1Step4Remember();
				}
				this.scenario.displayFooter(() => this.PrInstanceID, () => this.TalkInstanceID1, () => this.ActionInstanceID1, '2', '1', false, false);
				context.TalkCount = 2;
				context.ActionCount = 1;
				context.getFooterCounts();
            }
        );
    }

	private segment1Part5Debrief() {
		var context = this;
		context.scenario.gameManager.environment.blurFadeOut();
		context.scenario.displayDebrief(2500, () => {
			localStorage.setItem('ignoreResumePopup', 'true');
			window.location.reload();
		}, () => {
			context.segment1StepFinal();
		});
	}

	private segment1StepFinal() {
        var context = this;
        context.scenario.destroyAllUIInstances();
    	context.partEnd();
    }

	private partEnd() {
        var context = this;
		this.scenario.stopAmbientLoop();
		this.scenario.gameManager.customData.saveData.scenarios[context.scenario.currentLevel].lastPartId = this.partId;
		context.scenario.saveScore();
		context.onDone();
	}

    public PreloadUis(shouldHidePatientRecord?: boolean) {
        var context = this;
        this.PrInstanceID = (this.scenario as Scenario1).PrHolderID;
		context.scenario.gameManager.UiManager.updateUIInstance(this.PrInstanceID, {
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.Remember);
				}, 500);
				this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
				// if(this.RememberDisplayed === false) {
				// 	context.segment1Step4Remember();
				// }
			}
		})

		if(shouldHidePatientRecord) {
			this.scenario.gameManager.UiManager.hideUiInstance(this.PrInstanceID);
		} else {
			setTimeout(() => {
				context.scenario.update508Window(Window508Type.PatientRecord);
			}, 500);
		}

		(this.scenario as Scenario1).PrHolderID = this.PrInstanceID;

		context.TalkInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Talk',
			talks: [
				{
					toppx: '50px',
					titletext: 'How are you feeling?',
					onClicked: () => {
						this.segment1TalkFeeling();
					},
					disable: () => this.Talk1
				},
				{
					toppx: '150px',
					titletext: "Are you sure you aren't allergic to shellfish?",
					onClicked: () => {
						this.segment1TalkAllergy();
					},
					disable: () => this.Talk2
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);

		this.ActionInstanceID1 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Action',
			talks: [
				{
					toppx: '50px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment1ActionRRT();
					},
					disable: () => this.Action1
				}
			],
			onClosed: () => {
				this.scenario.update508Window(Window508Type.Main);
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
			}
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
	}

	private segment1TalkFeeling() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			scenario: this,
			toptitle: 'Talk',
			toppx: '70px',
			loadQuiz: true,
			titletext: 'How are you feeling?',
			isTalks: true,
			extBottom: true,
			extText: "I can't seem to get comfortable and I'm starting to get really itchy.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PObool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientObservation,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PObool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientObservation)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk1 = true;
				this.TalkCount = this.OldTalkCount - 1;
				// context.scenario.destroyAllUIInstances();
				// this.scenario.gameManager.UiManager.showUiInstance(this.TalkInstanceID1);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 7,
					quiztop: '5px',
					maxPoints: 300,
					talktext1: 'Patient Observation',
					talktext2: 'General',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'No active problems',
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Headache',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Nausea',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Trembling',
							onClicked: () => {
							},
						},
						{
							buttontop: '350px',
							buttontext: 'Sweating',
							onClicked: () => {
							},
						},
						{
							buttontop: '400px',
							buttontext: 'Restless',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '450px',
							buttontext: "Itchy",
							isCorrect: true,
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic11, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic15, () => {}, true);
		});
	}

	private segment1TalkAllergy() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Talk',
			scenario: this,
			toppx: '170px',
			loadQuiz: true,
			titletext: "Are you sure you aren't allergic to shellfish?",
			isTalks: true,
			extBottom: true,
			extText: "No, I'm not allergic.",
			onSubmit: (updatedConfig: TransformUIConfig) => {
				if(this.PAbool === false) {
					this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
						title: context.scenario.patientAssessment,
					}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2);
					this.PAbool = true;
				}
				for(var i = 0; i < updatedConfig.quiz.length; i++) {
					var quiz = updatedConfig.quiz[i];
					for(var p = 0; p < quiz.selectedTalkIndices.length; p++) {
						var talk = quiz.talks[quiz.selectedTalkIndices[p]];
						this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderNursesID, {
							header: p === 0 ? quiz.talktext2 : undefined,
							list: '<li>'+talk.buttontext+'</li>',
						}, context.scenario.allVisits, context.scenario.allHeaders, context.scenario.visit2, context.scenario.patientAssessment)
					}
				}

				this.scenario.evaluateScoreForTalk(updatedConfig);
				this.Talk2 = true;
				this.TalkCount = this.OldTalkCount - 1;
				// context.scenario.destroyAllUIInstances();
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				this.hideMoveShowTalk(this.MoveInstanceID, this.TalkInstanceID1, () => {
					context.getFooterCounts();
				});
			},
			quiz: [
				{
					quizheight: 4,
					quiztop: '5px',
					maxPoints: 250,
					talktext1: 'Patient Assessment',
					talktext2: 'Allergies',
					talks: [
						{
							buttontop: '150px',
							buttontext: 'None',
							isCorrect: true,
							onClicked: () => {
							},
						},
						{
							buttontop: '200px',
							buttontext: 'Iodine/Seafood',
							onClicked: () => {
							},
						},
						{
							buttontop: '250px',
							buttontext: 'Peanuts',
							onClicked: () => {
							},
						},
						{
							buttontop: '300px',
							buttontext: 'Dairy',
							onClicked: () => {
							},
						}
					]
				}
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		this.playVideoChapter(this.chapterIds.chapterCinematic12, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic15, () => {}, true);
		});
	}

	private segment1ActionRRT() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Call RRT',
			isTalks: true,
			onSubmit: () => {
				this.Action1 = true;
				this.ActionCount = this.OldActionCount - 1;
				this.scenario.displayModalPop(
					null,
					'RRT has been notified and is on its way. In the meantime, please continue caring for your patient.',
					() => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.scenario.destroyAllUIInstances();
						context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
						context.getFooterCounts();
					}
				);
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.TalkCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment2PreloadUis();
		}
		else if(this.TalkCount !== 0 && this.ActionCount === 0) {
			context.scenario.updateFooter(this.TalkCount.toString(), '0', false, true);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		}
		else {
			context.scenario.updateFooter(this.TalkCount.toString(), this.ActionCount.toString(), false, false)
		};
	}

	private segment2PreloadUis() {
        var context = this;
		this.playVideoChapter(this.chapterIds.chapterCinematic13, () => {
			this.playVideoChapter(this.chapterIds.chapterCinematic15, () => {}, true);
		});
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Take Vitals',
					onClicked: () => {
						this.segment2ActionVitals();
					},
					disable: () => this.Action2
				},
				{
					toppx: '150px',
					titletext: 'Get Benadryl from Pharmacy',
					onClicked: () => {
						this.segment2ActionFail();
					},
					disable: () => this.Action3
				},
				{
					toppx: '250px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment1ActionRRT2();
					},
					disable: () => this.Action1
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		if(this.Action1 === true) {
			context.ActionCount = 2
		}
		else {context.ActionCount = 3;}
		context.getFooterCounts2();
	}

	private segment2ActionVitals() {
		var context = this;
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.ActionInstanceID2 = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TalksActionsUI, {
			toptitle: 'Take Vitals',
			talks: [
				{
					toppx: '50px',
					titletext: 'Temperature',
					onClicked: () => {
						context.segment1ActionTemperature();
					},
					disable: () => this.Action21
				},
				{
					toppx: '150px',
					titletext: 'Blood Pressure',
					onClicked: () => {
						context.segment1ActionBloodPressure();
					},
					disable: () => this.Action22
				},
				{
					toppx: '250px',
					titletext: 'Pulse',
					onClicked: () => {
						context.segment1ActionPulse();
					},
					disable: () => this.Action23
				},
				{
					toppx: '350px',
					titletext: 'Respirations',
					onClicked: () => {
						context.segment1ActionRespirations();
					},
					disable: () => this.Action24
				},
				{
					toppx: '450px',
					titletext: 'O2 Sat Level',
					onClicked: () => {
						context.segment1ActionSatLevel();
					},
					disable: () => this.Action25
				}
			],
			onClosed: () => {
				this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
				this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			}
		});
	}

	private segment1ActionTemperature() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '70px',
			scenario: this,
			loadQuiz: true,
			titletext: 'Temperature',
			vitaltext: '99.1',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_temp.png',
			onSubmit: () => {
				this.Action21 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Temperature : 99.1</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionBloodPressure() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Blood Pressure',
			vitaltext: '104/60',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_bp.png',
			onSubmit: () => {
				this.Action22 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Blood Pressure : 104/60</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionPulse() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Pulse',
			vitaltext: '118',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_pulse.png',
			onSubmit: () => {
				this.Action23 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Pulse : 118</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRespirations() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '370px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Respirations',
			vitaltext: '28',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_respiration.png',
			onSubmit: () => {
				this.Action24 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>Respirations : 28</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -300px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionSatLevel() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID2);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '470px',
			loadQuiz: true,
			scenario: this,
			titletext: 'O2 Sat Level',
			vitaltext: '89% room air',
			vitalimg: './assets/images/general/icons/vitals/icon_vitals_o2.png',
			onSubmit: () => {
				this.Action25 = true;
				this.scenario.appendToScenarioDataEntry((this.scenario as Scenario1).holderVitalsID, {
					list: '<li>02 Sat Level : 89% room air</li>',
				})
				context.scenario.updateScore(100);
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID2);
				context.checkIfSubMenu();
			}
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment1ActionRRT2() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '270px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Call RRT',
			isTalks: true,
			onSubmit: () => {
				this.Action1 = true;
				this.ActionCount = this.OldActionCount - 1;
				this.scenario.displayModalPop(
					null,
					'RRT has been notified and is on its way. In the meantime, please continue caring for your patient.',
					() => {
						context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
						context.scenario.destroyAllUIInstances();
						context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
						context.getFooterCounts2();
					}
				);
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -200px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private segment2ActionFail() {
		var context = this;
		this.scenario.gameManager.environment.blurFadeIn();
		this.scenario.displayModalPop(
			null,
            "Your patient has had an adverse event. Please report to the nurses' station for remediation.",
            () => {
                context.scenario.destroyAllUIInstances();
				this.scenario.gameManager.environment.blurFadeOut();
				context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
				context.scenario.updateFooter('0', '0', true, true);
				context.scenario.hideFooter();
				context.segment2ActionChargeNurse();
            }
        );
	}

	private segment2ActionChargeNurse() {
		var context = this;
		//NEED FAIL ANIM, CHANGE CHAPTERCINEMATICS BELOW TO EACH PLAYER CHARACTER LOOP
		if(this.avatar1) {
			this.playVideoChapter(this.chapterIds.chapterCinematic76, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar2) {
			this.playVideoChapter(this.chapterIds.chapterCinematic77, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar3) {
			this.playVideoChapter(this.chapterIds.chapterCinematic74, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		} else if (this.avatar4) {
			this.playVideoChapter(this.chapterIds.chapterCinematic75, () => {
				//context.segment2ActionChargeNurseNext();
				context.scenario.gameManager.environment.blurFadeIn();
			});
		}
		setTimeout(() => {
			context.segment2ActionChargeNurseNext();
		}, 1000);
	}

	private segment2ActionChargeNurseNext() {
		var context = this;
		//context.scenario.gameManager.environment.blurFadeIn();
		context.scenario.showRemediation(
			'I would like to discuss Mr. Holder’s change in condition. When a patient is unstable, the nurse should remain at the bedside and call for help. A critically ill patient can deteriorate quickly and have a respiratory or cardiac arrest. Leaving the patient room resulted in Mr. Holder having an adverse event. Please return to Room #1 and begin caring for your patient again.',
			'./assets/images/general/icons/npc-headshots/ChargeNurse.png',
			() => {
				context.scenario.gameManager.environment.blurFadeOut();
				localStorage.setItem('ignoreResumePopup', 'true');
				window.location.reload();
			}
		)
	}

	private getFooterCounts2() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.Action2 === true) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment3PreloadUis();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.update508Window(Window508Type.Main);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
		};
	}

	private checkIfSubMenu() {
		var context = this;
		if(this.Action21 === true && this.Action22 === true && this.Action23 === true && this.Action24 === true && this.Action25 === true) {
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			this.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
			this.ActionCount = this.OldActionCount - 1;
			this.Action2 = true;
		};
		context.getFooterCounts2();
	}

	private segment3PreloadUis() {
        var context = this;
		this.playVideoChapter(this.chapterIds.chapterCinematic15, () => {}, true);
		context.scenario.gameManager.UiManager.updateUIInstance(this.ActionInstanceID1, {
			talks: [
				{
					toppx: '50px',
					titletext: 'Administer Supplemental O2',
					onClicked: () => {
						this.segment3ActionO2();
					},
					disable: () => this.Action4
				},
				{
					toppx: '150px',
					titletext: 'Call RRT',
					onClicked: () => {
						this.segment1ActionRRT3();
					},
					disable: () => this.Action1
				}
			]
		});
		this.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);

		if(this.Action1 === true) {
			context.ActionCount = 1
		}
		else {context.ActionCount = 2;}
		context.getFooterCounts3();
	}

	private segment3ActionO2() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			scenario: this,
			toppx: '470px',
			loadQuiz: true,
			titletext: 'Administer Supplemental O2.',
			isTalks: true,
			onSubmit: () => {
				context.scenario.updateScore(100);
				this.Action4 = true;
				this.ActionCount = this.OldActionCount - 1;
				setTimeout(() => {
					context.scenario.update508Window(Window508Type.TalkActionsUI);
				}, 1000);
				context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
				context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
				context.scenario.gameManager.environment.blurFadeOut();
				//NEED NASAL CANNULA ANIM ANIM, replace chapterCinematic below
				this.playVideoChapter(this.chapterIds.chapterCinematic16, () => {}, true);
				context.getFooterCounts3();
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -400px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
		context.scenario.gameManager.environment.blurFadeIn();
	}

	private segment1ActionRRT3() {
		var context = this;
		context.scenario.update508Window(Window508Type.TransformUI);
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		this.MoveInstanceID = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.TransformUI, {
			toptitle: 'Action',
			toppx: '170px',
			loadQuiz: true,
			scenario: this,
			titletext: 'Call RRT',
			isTalks: true,
			onSubmit: () => {
				this.Action1 = true;
				this.ActionCount = this.OldActionCount - 1;
				if(this.ActionCount === 0) {
					context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
					context.scenario.destroyAllUIInstances();
					context.getFooterCounts3();
				}
				else {
					this.scenario.displayModalPop(
						null,
						'RRT has been notified and is on its way. In the meantime, please continue caring for your patient.',
						() => {
							context.scenario.gameManager.UiManager.hideUiInstance(this.MoveInstanceID);
							context.scenario.destroyAllUIInstances();
							context.scenario.gameManager.UiManager.showUiInstance(this.ActionInstanceID1);
							context.getFooterCounts3();
						}
					);
				}
			},
			quiz: [
			]
		});
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				move: 'translate(0, -100px)',
				time: '2s'
			});
		}, 100);
		setTimeout(() => {
			this.scenario.gameManager.UiManager.updateUIInstance(this.MoveInstanceID, {
				loadQuiz: false,
			});
		}, 2000);
	}

	private getFooterCounts3() {
		var context = this;
		this.OldTalkCount = this.TalkCount;
		this.OldActionCount = this.ActionCount;
		if(this.ActionCount === 0) {
			context.scenario.updateFooter('0', '0', true, true);
			context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
			context.scenario.update508Window(Window508Type.Main);
			context.segment1ActionDone();
		}
		else {
			context.scenario.updateFooter('0', this.ActionCount.toString(), true, false);
			context.scenario.gameManager.UiManager.hideUiInstance(this.TalkInstanceID1);
			context.scenario.update508Window(Window508Type.Main);
		};
	}

	private segment1ActionDone() {
		var context = this;
		context.scenario.gameManager.UiManager.hideUiInstance(this.ActionInstanceID1);
		context.scenario.hideFooter();
		context.scenario.destroyAllUIInstances();
		context.scenario.gameManager.UiManager.hideAllUis([constants.uiTags.Hud]);
		this.playVideoChapter(this.chapterIds.chapterCinematic17, () => {
			this.scenario.gameManager.environment.blurFadeIn();
			context.segment3showSbar();
		});
	}

	private segment3showSbar() {
		var context = this;
		context.scenario.update508Window(Window508Type.SbarUI)
		this.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.SbarUI, {
			s: {
				maxPoints: 200,
				options: [
					{
						text: 'Change in LOC',
						isCorrect: false
					},
					{
						text: 'Hypoglycemia',
						isCorrect: false
					},
					{
						text: 'Allergic reaction',
						isCorrect: true
					},
					{
						text: 'Trouble breathing',
						isCorrect: true
					}
				]
			},
			basic: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).holderBasicID),
			nurses: this.scenario.getScenarioDataEntryItems((this.scenario as Scenario1).holderNursesID),
			r: {
				maxPoints: 200,
				options: [
					{
						text: 'Transfer care to ICU',
						isCorrect: true
					},
					{
						text: 'Medication',
						isCorrect: false
					},
					{
						text: 'CT Scan',
						isCorrect: false
					},
					{
						text: 'Discharge',
						isCorrect: false
					}
				]
			},
			correctFeedback: 'Good job, you have correctly relayed critical information. Please review the SBAR and continue.',
			incorrectFeedback: 'You have incorrectly relayed critical information. Accurate patient information ensures patient safety and quality care provided by medical staff and Providers. Please continue to review the corrected SBAR.',
			onSubmitted: (result: SbarUIConfig) => {
				this.scenario.evaluateScoreForSbar(result);
			},
			onClose: (result: SbarUIConfig) => {
				context.scenario.destroyAllUIInstances();
				context.scenario.showProvider(
					"We're going to transfer Mr. Holder to ICU.",
					() => {
						context.segment1Part5Debrief();
					}
				);
			},
			onSetWindow: (window: Window508Type) => {
				context.scenario.update508Window(window);
			}
		});
	}
}